// /care/account-delete — 덴클 케어 계정 삭제 안내·요청 (덴클 케어 1차 W7, 2026-10-04 계획_환자앱1차_통합 · 구글 플레이 계정 삭제 웹 주소용)
// 비로그인 공개. 주 경로 = 앱 안 내 정보 › 계정 삭제(누르면 즉시 처리, p-1.0 제9조①②). 앱을 쓸 수 없을 때 = 고객센터 전화·전자우편 → 10일 이내 처리·완료 통지
//   (정본 §4-6·§9 I-9 와 같은 창구·기간).
// 계획서 W7 의 "웹 로그인 후 요청 기록"은 넣지 않았다 — 웹에 환자 로그인(휴대폰 문자·카카오·Apple)이 없고, 요청을 받을 서버 함수도 아직 없다.
//   서버 함수가 생기면 이 페이지에 요청 양식을 붙인다(보고서 미결 사항).
// 게이트: "10일 이내 삭제"는 자동 삭제(계획 S8) 구현 전 게시 금지(정본 §0 P0) → 이 안내는 덴클 케어 약관(CARE_TERMS)이 확정(final)된 뒤에만 보인다.
//   그 전에는 "준비 중" — 약관 확정 = 서버 P0 해소 뒤라는 같은 조건을 쓴다(TODO 가 남은 채 배포돼도 안전).
// 의료법: 가격·할인·후기·유인 표현 없음. 연락처는 SiteFooter 상수 공용.
import React from 'react';
import CarePageShell, { CS } from './CarePageShell';
import { CONTACT_EMAIL, CONTACT_PHONE } from '../common/SiteFooter';
import { CARE_APP_NAME } from '../../config/careApp';
import { CARE_TERMS, isCareTextReady } from '../../config/careLegal';

function CareAccountDelete() {
    const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(`[${CARE_APP_NAME}] 계정 삭제 요청`)}`;
    if (!isCareTextReady(CARE_TERMS)) {
        return (
            <CarePageShell title="계정 삭제" meta={`${CARE_APP_NAME} 앱 이용자용`}>
                <div style={CS.pending}>준비 중입니다.<br />{`문의: 고객센터 ${CONTACT_PHONE}`}</div>
            </CarePageShell>
        );
    }
    return (
        <CarePageShell title="계정 삭제" meta={`${CARE_APP_NAME} 앱 이용자용`}>
            <h2 style={CS.h2}>1. 앱에서 바로 삭제하기</h2>
            <p style={CS.p}>{`${CARE_APP_NAME} 앱 › 내 정보 › 계정 삭제를 누르면 바로 처리되고, 처리가 끝나면 앱 화면에 완료를 알려 드립니다. 전화나 전자우편 같은 다른 절차를 거치지 않아도 됩니다.`}</p>
            {/* 정본 v2.6 §1-5(법적보안 10-05) — 서버 동작(생년월일 미확인 등록은 연결만 끊김, clinic-patients.js:2552-2558)과 일치. 웹은 계정별 상태를 모르므로 모든 경우를 한 문단에 */}
            <p style={CS.p}>{'계정을 삭제하면 로그인 정보와 알림 기록이 바로 지워집니다. 등록한 치과 중 앱에서 생년월일 확인을 마친 치과에는 등록 삭제 요청이 전달되어, 치과의 등록 정보와 보철물 제작 기록이 10일 이내에 삭제됩니다. 생년월일 확인을 마치지 않은 치과의 등록은 계정 연결만 끊기고 그 치과의 환자 명부에 남습니다. 그 등록도 지우려면 계정을 삭제하기 전에 앱의 내 정보 › 등록 삭제 요청에서 생년월일을 확인하고 요청하시거나, 그 치과에 직접 요청해 주세요. 삭제한 뒤에는 되돌릴 수 없습니다.'}</p>

            <h2 style={CS.h2}>2. 앱을 쓸 수 없을 때</h2>
            <p style={CS.p}>아래 고객센터 전화나 전자우편으로 요청해 주세요. 본인임을 확인한 뒤 요청을 받은 날부터 10일 이내에 처리하고, 알려 주신 연락처로 완료를 알려 드립니다.</p>
            <div style={CS.box}>
                <div><b>전화</b> <a href={`tel:${CONTACT_PHONE}`} style={CS.link}>{CONTACT_PHONE}</a></div>
                <div style={{ marginTop: 4 }}><b>전자우편</b> <a href={mailto} style={CS.link}>{CONTACT_EMAIL}</a></div>
                <div style={{ marginTop: 4 }}><b>전자우편 제목</b> {`[${CARE_APP_NAME}] 계정 삭제 요청`}</div>
                <div style={{ marginTop: 4 }}><b>알려 주실 내용</b> 가입할 때 쓴 방법(휴대폰 번호·카카오·Apple)과 연락받을 방법</div>
            </div>

            <h2 style={CS.h2}>3. 삭제 뒤 남는 정보</h2>
            <p style={CS.p}>계정 삭제 처리 사실(계정 식별값·일시)은 접속기록으로 2년 보관한 뒤 삭제합니다. 자세한 내용은 개인정보 처리방침에 있습니다.</p>
            {/* 정본 v2.6 §1-5 — 삭제 후에도 남는 데이터 고지(구글 플레이 요건) */}
            <p style={CS.p}>{'생년월일 확인을 마치지 않은 치과의 등록 정보는 그 치과의 환자 명부에 남으며, 마지막 의뢰서 작성일(연결된 의뢰서가 없으면 등록일)부터 5년이 지나면 자동으로 삭제됩니다.'}</p>

            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 20 }}>
                <a href="/care/terms" style={CS.link}>{`${CARE_APP_NAME} 이용약관`}</a>
                <a href="/privacy" style={CS.link}>개인정보 처리방침</a>
            </div>
        </CarePageShell>
    );
}

export default CareAccountDelete;
